import { ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';


export class InTheViewController {

    private  _domElement: ElementRef;
    private _intersectionObserver?: IntersectionObserver;
    private _templateRef: TemplateRef<any>;
    private _view: ViewContainerRef;

    constructor(domElement: ElementRef, templateRef: TemplateRef<any>, vc: ViewContainerRef) {
        this._domElement = domElement;
        this._templateRef = templateRef;
        this._view = vc;
        this.createObserver(this._domElement);
    }

    private createObserver(domElement: ElementRef) {
        this._intersectionObserver = new IntersectionObserver(entries => {
               entries.forEach( entriy => {
                   if (entriy.intersectionRatio > 0) {
                       const view = this._templateRef.createEmbeddedView(null);
                       this._view.insert(view);
                       this._intersectionObserver.unobserve(domElement.nativeElement);
                       this._intersectionObserver.disconnect();
                   }
               } );
        }, {});

        this._intersectionObserver.observe(this._domElement.nativeElement);
    }

}
